export default __webpack_public_path__ + "static/media/shoe.ee73b5b5.jpg";